function initPageLoaded() {
  const vacancyFormField = document.querySelector('[data-vacancy-field] input');
  if (vacancyFormField) {
    vacancyFormField.value = window.location.href;
  }
}

document.addEventListener('DOMContentLoaded', initPageLoaded);